import { ChevronsLeft } from 'lucide-react';
import { Eye } from 'lucide-react';
import { ChevronsRight } from 'lucide-react';
import { ChevronRight } from 'lucide-react';
import { ArrowUpAZ } from 'lucide-react';
import { ArrowDownZA } from 'lucide-react';
import { ArrowUp } from 'lucide-react';
import { ChevronLeft } from 'lucide-react';
import "./Tableau.scss"
import React, {useEffect, useState} from "react";
import {
    flexRender,
    Column, Table, VisibilityState
} from "@tanstack/react-table";
import {IconeLoader} from "../icone/icone";
import {NativeSelect, Popover} from "@mantine/core";
import { useSearchParams } from 'react-router-dom'

type col_local_storage = {
    table_id: string
    state_cols:Column<any, unknown>[]
}

export function Tableau({table, donnees}: { table: Table<any>, donnees: any[] | null }) {

    const [col_loaded, setCol_loaded] = useState(false);

    function getTableID()
    {
        return "tab-" + table.getAllLeafColumns().map(c => c.id + "-") + "-url" + window.location.href;
    }
    function getLocalStorageFull():col_local_storage[]
    {
        let localsto = localStorage.getItem('table_cols');
        let state_cols:col_local_storage[] = []
        if (localsto) {
            state_cols = JSON.parse(localsto);
        }
        return state_cols
    }
    function getLocalStorage():col_local_storage|null
    {
        let state_cols = getLocalStorageFull()
        let state_col:col_local_storage|null = null
        state_cols.map(col => {
            if (col.table_id === getTableID())
            {
                state_col = col;
            }
        })

        return state_col
    }

    const [written_local_storage, setWritten_local_storage] = useState<string>("");

    useEffect(() => {
        //Ecriture des colonnes dans le localstorage
        if (col_loaded)
        {
            let localsto = getLocalStorageFull()
            let cette_table = getLocalStorage();
            if (cette_table)
            {
                localsto = localsto.map(_table => {
                    if (cette_table && _table.table_id === cette_table.table_id)
                    {
                        _table.state_cols = table.getVisibleLeafColumns()
                    }
                    return _table
                })
            }
            else{
                localsto.push({
                    table_id: getTableID(),
                    state_cols: table.getVisibleLeafColumns()
                })
            }

            const serializedState = JSON.stringify(localsto);
            if (written_local_storage !== serializedState){
                localStorage.setItem('table_cols', serializedState);
                setWritten_local_storage(serializedState)
                console.log("Ecriture")
            }

        }

    }, [table.getVisibleLeafColumns()]) //


    useEffect(() => {
        //Lecture des colonnes dans le localstorage
        console.log("lecture")
        let _table = getLocalStorage()
        if (_table) {
            let retour:VisibilityState = {};
            table.getAllLeafColumns().map(col_toutes => {
                if (_table)
                {
                    retour[col_toutes.id] = _table.state_cols.filter(col_visible => col_visible.id === col_toutes.id ).length > 0
                }
            })
            table.setColumnVisibility(retour);
        }

        setTimeout(() => {setCol_loaded(true)}, 1000);
    }, [])

    if (donnees === null) {
        return (
            <div className={"tableauContainer"}>
                {}
                <table>
                    <div className={"en-ligne"} style={{justifyContent: "center"}}><IconeLoader />Chargement...
                    </div>
                </table>
            </div>
        )
    }


    return (
        <div className={"tableauContainer"}>
            <table>
                <thead>
                {table.getHeaderGroups().map(headerGroup => (
                    <tr key={headerGroup.id}>
                        {headerGroup.headers.map(header => {
                            return (
                                <th key={header.id} colSpan={header.colSpan}>
                                    {header.isPlaceholder ? null : (
                                        <div>
                                            <span onClick={header.column.getToggleSortingHandler()}>
                                                {flexRender(
                                                    header.column.columnDef.header,
                                                    header.getContext()
                                                )}

                                                {{
                                                    asc: <ArrowUpAZ/>,
                                                    desc: <ArrowDownZA/>,
                                                }[header.column.getIsSorted() as string] ?? null}
                                            </span>


                                            {header.column.getCanFilter() ? (
                                                <div>
                                                    <Filter column={header.column} table={table}/>
                                                </div>
                                            ) : null}
                                        </div>
                                    )}
                                </th>
                            )
                        })}
                    </tr>
                ))}
                </thead>
                <tbody>
                {table.getRowModel().rows.map(row => {
                    return (
                        <tr key={row.id}>
                            {row.getVisibleCells().map(cell => {
                                return (
                                    <td key={cell.id}>
                                        {flexRender(
                                            cell.column.columnDef.cell,
                                            cell.getContext()
                                        )}
                                    </td>
                                )
                            })}
                        </tr>
                    )
                })}
                {table.getRowModel().rows.length === 0 && (
                    <tr>
                        <td colSpan={100}>
                            <p className={"notice"}>Aucune ligne à afficher...</p>
                        </td>
                    </tr>
                )}

                </tbody>

            </table>

            <div className="en-ligne pagination">
                <Popover width={200} position="bottom" withArrow shadow="md">
                    <Popover.Target>
                        <button className={"sec"}><Eye/> Colonnes</button>
                    </Popover.Target>
                    <Popover.Dropdown>
                        {table.getAllLeafColumns().map(column => {
                            return (
                                <div key={column.id} className="colonnes_selector">
                                    <label>
                                        <input
                                            {...{
                                                type: 'checkbox',
                                                checked: column.getIsVisible(),
                                                onChange: column.getToggleVisibilityHandler(),
                                            }}
                                        />{' '}

                                        {column.id}
                                    </label>
                                </div>
                            )
                        })}
                    </Popover.Dropdown>
                </Popover>
                <span className="flex items-center gap-1">
                  {/*<div>Page</div>*/}
                    <strong>Page {' '}
                        {table.getState().pagination.pageIndex + 1} sur{' '}
                        {table.getPageCount()}
                  </strong>
                </span>
                <button
                    className="border rounded p-1"
                    onClick={() => table.setPageIndex(0)}
                    disabled={!table.getCanPreviousPage()}
                >
                    <ChevronsLeft/>
                </button>
                <button
                    className="border rounded p-1"
                    onClick={() => table.previousPage()}
                    disabled={!table.getCanPreviousPage()}
                >
                    <ChevronLeft/>
                </button>
                <button
                    className="border rounded p-1"
                    onClick={() => table.nextPage()}
                    disabled={!table.getCanNextPage()}
                >
                    <ChevronRight/>
                </button>
                <button
                    className="border rounded p-1"
                    onClick={() => table.setPageIndex(table.getPageCount() - 1)}
                    disabled={!table.getCanNextPage()}
                >
                    <ChevronsRight/>
                </button>

            </div>


        </div>

    )
}


function Filter({
                    column,
                    table,
                }: {
    column: Column<any, any>
    table: Table<any>
}) {
    const [searchParams, setSearchParams] = useSearchParams()

    const firstValue = table
        .getPreFilteredRowModel()
        .flatRows[0]
        ?.getValue(column.id)

    const isNumber = false// typeof firstValue === 'number'
    const columnId = column.id

    /**
     * Restore filter from URL on mount
     */
    useEffect(() => {
        if (isNumber) {
            const min = searchParams.get(`${columnId}Min`)
            const max = searchParams.get(`${columnId}Max`)

            if (min !== null || max !== null) {
                column.setFilterValue([
                    min !== null ? Number(min) : undefined,
                    max !== null ? Number(max) : undefined,
                ])
            }
        } else {
            const value = searchParams.get(columnId)
            if (value !== null) {
                column.setFilterValue(value)
            }
        }
    }, [columnId])

    /**
     * Update URL when filter changes
     */
    const updateSearchParams = (updates: Record<string, string | null>) => {
        const next = new URLSearchParams(searchParams)

        Object.entries(updates).forEach(([key, value]) => {
            if (value === null || value === '') {
                next.delete(key)
            } else {
                next.set(key, value)
            }
        })

        setSearchParams(next, { replace: true })
    }

    const columnFilterValue = column.getFilterValue()

    return isNumber ? (
        <div className="table_input_min_max">
            <input
                type="number"
                value={(columnFilterValue as [number?, number?])?.[0] ?? ''}
                onChange={e => {
                    const value = e.target.value
                    column.setFilterValue((old: [number?, number?]) => [
                        value === '' ? undefined : Number(value),
                        old?.[1],
                    ])

                    updateSearchParams({
                        [`${columnId}Min`]: value || null,
                    })
                }}
                placeholder="Min"
                className="w-24 border shadow rounded"
            />

            <input
                type="number"
                value={(columnFilterValue as [number?, number?])?.[1] ?? ''}
                onChange={e => {
                    const value = e.target.value
                    column.setFilterValue((old: [number?, number?]) => [
                        old?.[0],
                        value === '' ? undefined : Number(value),
                    ])

                    updateSearchParams({
                        [`${columnId}Max`]: value || null,
                    })
                }}
                placeholder="Max"
                className="w-24 border shadow rounded"
            />
        </div>
    ) : (
        <input
            type="text"
            value={(columnFilterValue ?? '') as string}
            onChange={e => {
                const value = e.target.value
                column.setFilterValue(value)
                updateSearchParams({
                    [columnId]: value || null,
                })
            }}
            placeholder="Recherche..."
            className="input_recherche_table"
        />
    )
}
